import { useState } from "react";
import PropTypes from "prop-types";

import Popover from "@mui/material/Popover";
import TableRow from "@mui/material/TableRow";
import MenuItem from "@mui/material/MenuItem";
import TableCell from "@mui/material/TableCell";
import IconButton from "@mui/material/IconButton";
import Iconify from "../../../components/iconify/iconify";
import { fDateTime, fTime } from "../../../utils";
import ImageWithFallback from "../../../components/ImageWithFallback";

// ----------------------------------------------------------------------

export default function UserTableRow({
  selected,
  rowNumber,
  description,
  title,
  file,
  date,
  time,
  location,
  isArchived,
  onDelete,
  onEdit,
  onArchive,
  onRestore,
  handleClick,
}) {
  const [open, setOpen] = useState(null);

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleMenuAction = (action) => () => {
    handleCloseMenu();
    action();
  };

  return (
    <>
      <TableRow hover tabIndex={-1} selected={selected}>
        {/* <TableCell padding="checkbox">
          <Checkbox disableRipple checked={selected} onChange={handleClick} />
        </TableCell> */}

        <TableCell
          sx={{
            fontSize: { xs: "0.75rem", sm: "0.875rem" },
            padding: { xs: "8px 4px", sm: "16px" },
            width: { md: "5%" },
            fontWeight: 500,
          }}
        >
          {rowNumber}
        </TableCell>

        <TableCell>{title}</TableCell>
        <TableCell>{fDateTime(date)}</TableCell>
        <TableCell>{fTime(time)}</TableCell>
        <TableCell>{location}</TableCell>
        <TableCell dangerouslySetInnerHTML={{ __html: description }} />

        <TableCell>
          <ImageWithFallback path={file} alt="" style={{ width: 100 }} />
        </TableCell>

        <TableCell align="right">
          <IconButton onClick={handleOpenMenu}>
            <Iconify icon="eva:more-vertical-fill" />
          </IconButton>
        </TableCell>
      </TableRow>

      <Popover
        open={!!open}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: { width: 140 },
        }}
      >
        {!isArchived && (
          <>
            <MenuItem onClick={handleMenuAction(onEdit)}>
              <Iconify icon="eva:edit-fill" sx={{ mr: 2 }} />
              Edit
            </MenuItem>

            <MenuItem onClick={handleMenuAction(onArchive)}>
              <Iconify icon="eva:archive-fill" sx={{ mr: 2 }} />
              Archive
            </MenuItem>
          </>
        )}

        {isArchived && (
          <MenuItem onClick={handleMenuAction(onRestore)}>
            <Iconify icon="eva:undo-fill" sx={{ mr: 2 }} />
            Restore
          </MenuItem>
        )}

        <MenuItem onClick={handleMenuAction(onDelete)} sx={{ color: "error.main" }}>
          <Iconify icon="eva:trash-2-outline" sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>
    </>
  );
}

UserTableRow.propTypes = {
  avatarUrl: PropTypes.any,
  company: PropTypes.any,
  handleClick: PropTypes.func,
  isVerified: PropTypes.any,
  name: PropTypes.any,
  role: PropTypes.any,
  selected: PropTypes.any,
  status: PropTypes.string,
  rowNumber: PropTypes.number,
};
